import {
  ADD_USER_FAIL,
  ADD_USER_SUCCESS,
  CLEAR_ERRORS,
  DELETE_USER_FAIL,
  DELETE_USER_SUCCESS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  SEND_ACTIVATION_FAIL,
  SEND_ACTIVATION_SUCCESS,
  START_LOADING,
  UPDATE_USER_FAIL,
  UPDATE_USER_SUCCESS,
} from './actions';

import { GENERIC_ERROR } from 'constants/errors.constants';

export const initialState = {
  users: [],
  errors: {},
  loading: false,
};

function usersServiceReducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_ERRORS:
      return {
        ...state,
        errors: initialState.errors,
      };
    case ADD_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: [...state.users, action.payload.user],
        errors: initialState.errors,
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        users: [...state.users].filter((user) => user.id !== action.payload.userId), // Remove user from local store.
        loading: false,
        errors: initialState.errors,
      };
    case SEND_ACTIVATION_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: initialState.errors,
      };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload.users,
        errors: initialState.errors,
      };
    case GET_USERS_FAIL:
      return {
        ...state,
        loading: false,
        users: initialState.users,
        errors: action.payload.errors || GENERIC_ERROR,
      };
    case START_LOADING:
      return { ...state, loading: true, errors: initialState.errors };
    case UPDATE_USER_SUCCESS: {
      const newUsersState = [...state.users];
      const updatedUserIndex = newUsersState.findIndex((user) => user.profile.id === action.payload.userProfile.id);
      newUsersState[updatedUserIndex].profile = action.payload.userProfile;
      return {
        ...state,
        loading: false,
        users: newUsersState,
        errors: initialState.errors,
      };
    }
    case SEND_ACTIVATION_FAIL:
    case DELETE_USER_FAIL:
    case ADD_USER_FAIL:
    case UPDATE_USER_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors || GENERIC_ERROR,
      };
    default:
      return state;
  }
}

export default usersServiceReducer;
